import { useCallback, useState } from "react"

export default function useAsyncErrorHandler() {
  const [, setError] = useState();
  return useCallback(e => setError(() => { throw e; }), [setError]);
}